import { render, staticRenderFns } from "./DetailsGroupCard.vue?vue&type=template&id=6d8501f0&scoped=true"
import script from "./DetailsGroupCard.vue?vue&type=script&lang=ts"
export * from "./DetailsGroupCard.vue?vue&type=script&lang=ts"
import style0 from "./DetailsGroupCard.vue?vue&type=style&index=0&id=6d8501f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8501f0",
  null
  
)

export default component.exports